// TouchControls.jsx
import React from "react";

export default function TouchControls({ onMove }) {
  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50 flex flex-col items-center space-y-2">
      {/* Up */}
      <button onClick={() => onMove("up")} className="arrow-btn">⬆️</button>

      {/* Left + Right */}
      <div className="flex space-x-3 mt-1">
        <button onClick={() => onMove("left")} className="arrow-btn">⬅️</button>
        <button onClick={() => onMove("right")} className="arrow-btn">➡️</button>
      </div>

      {/* Down */}
      <button onClick={() => onMove("down")} className="arrow-btn mt-1">⬇️</button>

      <style jsx>{`
        .arrow-btn {
          background-color: rgba(255, 255, 255, 0.95);
          font-size: 1.25rem;
          width: 42px;
          height: 42px;
          border-radius: 9999px;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
          display: flex;
          align-items: center;
          justify-content: center;
          transition: transform 0.1s ease;
        }
        .arrow-btn:active {
          transform: scale(0.95);
        }
      `}</style>
    </div>
  );
}
